import { memo, ReactNode, VFC } from "react";
import Div100vh from "react-div-100vh";
import { Container, Grid, GridItem, Spacer, Stack } from "@chakra-ui/react";

import { Header } from "../organisms/layout/Header";
import { Footer } from "../organisms/layout/Footer";

type Props = {
  children: ReactNode;
};

export const HeaderLayout: VFC<Props> = memo((props) => {
  const { children } = props;

  return (
    <Div100vh>
      <Grid
        templateAreas={`"header"
                        "main"
                        "footer"`}
        gridTemplateRows={'auto 1fr auto'}
        gridTemplateColumns={'1fr'}
        gap='3'
        height={"full"}
      >
        <GridItem area={'header'}>
          <Header />
        </GridItem>
        <GridItem area={'main'}>
          {children}
        </GridItem>
        <GridItem area={'footer'}>
        <Footer />
        </GridItem>
      </Grid>
    </Div100vh>
  );
});
